module.exports = __webpack_public_path__ + "img/11-3.0860e065.png";